<div class="py-4">
  @if (isLoading()) {
    <div class="row g-5" data-testid="course-progress-loading">
      <ng-container *ngTemplateOutlet="progressCardSkeleton"></ng-container>
      <ng-container *ngTemplateOutlet="progressCardSkeleton"></ng-container>
      <ng-container *ngTemplateOutlet="progressCardSkeleton"></ng-container>
      <ng-container *ngTemplateOutlet="progressCardSkeleton"></ng-container>
    </div>
  } @else if (!courses().length) {
    <div class="empty-state" data-testid="course-progress-empty">
      <span class="empty-state__mark">
        <app-keenicon name="book-open" class="fs-2tx"></app-keenicon>
      </span>
      <p class="empty-state__title">{{ "APP.NO_COURSE_YET" | translate }}</p>
      <p class="empty-state__body">{{ "MONITOR.PROGRESS_EMPTY_HINT" | translate }}</p>
    </div>
  } @else {
    <div class="row g-5" data-testid="course-progress">
      @for (course of courses(); track course.id) {
        <div class="col-12 col-lg-6">
          <div class="card h-100 border border-gray-200">
            <div class="card-body d-flex gap-4">
              <img
                class="progress-card__thumb rounded-nested bg-light flex-shrink-0"
                [src]="course.course_image_url ? fileUrl + course.course_image_url : './assets/media/svg/files/blank-image.svg'"
                [attr.alt]="course.course_name"
              />

              <div class="flex-grow-1 min-w-0">
                <p class="fs-5 fw-semibold text-overflow-line-2 mb-2">{{ course.course_name }}</p>

                <div class="progress-line">
                  <span class="progress-line__track">
                    <span
                      class="progress-line__fill"
                      [ngClass]="bandOf(course)"
                      [style.width.%]="progressOf(course)"
                    ></span>
                  </span>
                  <span class="progress-line__value">{{ progressOf(course) }}%</span>
                </div>

                <div class="d-flex flex-wrap gap-4 fs-8 text-muted mt-3">
                  <span>
                    {{ "ONLINE_CLASS.SPENT_TIME" | translate }}
                    <b class="text-gray-800">{{ course.duration_spent | durationVideo : "fullTime" }}</b>
                    / {{ course.expire_duration_video | durationVideo : "fullTime" }}
                  </span>
                  @if (course.expire_date) {
                    <span>
                      {{ "ONLINE_CLASS.EXPIRE_DATE" | translate }}
                      <b class="text-gray-800">{{ course.expire_date | bEDate }}</b>
                    </span>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  }
</div>

<ng-template #progressCardSkeleton>
  <div class="col-12 col-lg-6">
    <div class="card h-100 border border-gray-200">
      <div class="card-body d-flex gap-4">
        <div class="skeleton w-100px h-75px flex-shrink-0"></div>
        <div class="flex-grow-1">
          <div class="skeleton h-20px w-75 mb-4"></div>
          <div class="skeleton h-8px w-100 mb-4"></div>
          <div class="d-flex flex-wrap gap-4">
            <div class="skeleton h-10px w-150px"></div>
            <div class="skeleton h-10px w-125px"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
